export default "__VITE_ASSET__e$aW8AX9__"